import * as StatisticsAction from "./StatisticsAction";

export default function statisticsReducer(state = {}, action) {
    switch (action.type) {
        case StatisticsAction.REQUEST_SUBSCRIBERS_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    subscribers: {
                        ...action.payload
                    }
                };
            }
        case StatisticsAction.REQUEST_ONE_OFFS_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    oneOffs: {
                        ...action.payload
                    }
                };
            }

        case StatisticsAction.REQUEST_SALES_BY_PRODUCT_FINISHED:
            return {
                    ...state,
                    salesByProduct: {
                        ...action.payload
                    }
                };

        case StatisticsAction.REQUEST_SALES_BY_USER_FINISHED:
            return {
                    ...state,
                    salesByUser: {
                        ...action.payload
                    }
                };

        case StatisticsAction.REQUEST_REPORTS_FINISHED:
            return {
                    ...state,
                    singleIsinReport: {
                        ...action.payload
                    }
                };
            
        default:
            return state;
    }
}
